export default __webpack_public_path__ + "images/CN.f87eae7.png";